import React from 'react';

import AdjustableSmtStencilFixtureImg from 'images/pu/product_tabs/accessories/adjustable_smt_stencil_fixture.png';
import SD300ManualSmtStencilPrinterImg from 'images/pu/product_tabs/accessories/white_bg_sd300_printer.png';

const getImage = (product_slug, images) => {
  switch(product_slug){
    case 'adjustable-smt-stencil-fixture':
      return AdjustableSmtStencilFixtureImg;
    case 'sd300-manual-smt-stencil-printer':
      return SD300ManualSmtStencilPrinterImg;
    default:
      return images[0].small_url;
  }
}

const ProductImage = ({product_name, product_slug, product_url, images}) => {

  return (
    <div className='d-flex justify-content-center product-image'>
      <a href={product_url} target='_blank'>
        <img src={getImage(product_slug, images)} alt={product_name}/>
      </a> 
    </div>
  )
}

export default ProductImage;